module.exports = __webpack_public_path__ + "files/bbd67d5794b3ffa297a1db199111ea2f.png";